// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"language-dropdown_dropdown__kjIme odds-format-selector_oddsDropdown__gpdl3"};